import Node from 'ln/node/Node';
import Lang from 'ln/lang/Lang';
import Course from './Course';
import CourseElement from './CourseElement';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';
import CustomSlrgUserSequenceModel from '../models/CustomSlrgUserSequenceModel';
import UserFileList from './UserFileList';


class SlrgSequence extends CourseElement {

	public userFileList:UserFileList;
	
	constructor( public model:SlrgUserSequenceModel, private courseView: Course ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

		// userfile list
		this.userFileList = new UserFileList( this.model );
		this.userFileList.render();
		this.node.js( 'userfiles' ).append( this.userFileList.node );

		// listen for changes
		this.node.js( 'time' ).change.add( this.onTimeChange, this );
		this.node.js( 'notes' ).blur.add( this.onNoteChange, this );
		const done = this.node.js( 'done' );
		done.click.add( this.onDoneClicked, this );
		done.native.classList.toggle( '-checked', this.model.done );

		this.node.js('expand').click.add( () => {
			this.node.toggleClass( 'expanded' );
		});

		this.node.js( 'customize' ).click.add( this.customizeSequence, this );
		
		this.renderDisplayTime();

		this.blankLinks();

	}
	
	private onTimeChange( n:Node ){
		this.model.time = parseInt( n.value );
		this.model.save();
		
		// update round time button
		this.node.js( 'timeline-button' ).html = n.value + '\'';
		
		// update the course header
		this.courseView.rerenderComputedProperties();
		
		this.model.course.rerenderDisplayTime.dispatch();
	}
	
	/**
	 * Callback when the note has changed
	 */
	private onNoteChange( n:Node ) {
		this.model.note = n.html;
		this.model.save();
	}

	private onDoneClicked( n:Node ){
		this.model.done = !this.model.done;
		this.model.save();
		n.native.classList.toggle( '-checked' );
	}

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}

	private customizeSequence() {
		var model = new CustomSlrgUserSequenceModel( {
			origin: this.model.object().origin,
			title: this.model.title,
			module: this.model.module,
			time: this.model.time,
			done: this.model.done,
			method_location: this.model.method_location,
			objective: this.model.objective,
			expertise: this.model.expertise,
			content: this.model.content,
			userfiles: this.model.userfiles,
			modelName: "App\\CustomSlrgUserSequence"
		});

		model.backend = this.model.backend;
		
		model.save().then( function( model:CustomSlrgUserSequenceModel ) {
			model.course = this.model.course;

			// set origin with slides for slideview
			model.set( 'origin', this.model.object().origin );

			// remove listener on rerender display time on old model
			this.model.course.rerenderDisplayTime.remove( this.renderDisplayTime, this );

			// remove the old model and add the new one
			var index = this.model.course.sequences.index( this.model );
			this.model.course.sequences.removeAt( index );
			this.model.course.sequences.add( model, index );

			// because of some sort of race condition, make shure relations are properly saved
			this.model.course.save();

		}.bind( this ) );
	}
}

export default SlrgSequence;